<div [class.readonly]="readonly">
  <label *ngIf="label" [for]="id"
    >{{ label }}
    <app-dc-popover
      *ngIf="helpText"
      [body]="helpText"
      [class.helpText]="helpText"
    ></app-dc-popover
  ></label>
  <div class="inputContainer input-group" [skelo]="loading">
    <input
      [formControl]="control"
      [type]="type"
      [class]="'form-control input percentNum'"
      [readonly]="readonly"
      [placeholder]="placeholder == undefined ? '' : placeholder"
      autocomplete="new-input"
      [id]="id"
      [mask]="mask"
      [thousandSeparator]="thousandSeparator"
      [dropSpecialCharacters]="dropSpecialCharacters"
      [allowNegativeNumbers]="allowNegativeNumbers"
      (input)="setValue($event)"
    />
    <app-dc-control-validation
      *ngIf="control.touched"
      [status]="getValidationStatus()"
      class="{{
        control.hasError('required') && control.touched ? 'required' : ''
      }}"
      body="{{ customErrorMessage ? customErrorMessage + '.' + '<br/>' : '' }}{{
        control.hasError('required') ? 'Required field' + '.' + '<br/>' : ''
      }}{{ control.hasError('incorrect') ? control.errors.message + '.' : '' }}"
    ></app-dc-control-validation>
    <div
      class="percentNumberContainer input-group-append"
      [ngClass]="{ lock: lockDefault }"
      (click)="toggleValues()"
    >
      <button
        *ngIf="(allowToggleButtons && unit === 'abs') || !allowToggleButtons"
        [ngClass]="unit === 'abs' && !allowToggleButtons ? 'selected' : ''"
        class="numPercentButton"
        (click)="setUnit('abs')"
        [disabled]="readonly"
      >
        #
      </button>
      <button
        *ngIf="(allowToggleButtons && unit === 'pct') || !allowToggleButtons"
        [ngClass]="unit === 'pct' && !allowToggleButtons ? 'selected' : ''"
        class="numPercentButton"
        (click)="setUnit('pct')"
        [disabled]="readonly"
      >
        %
      </button>
    </div>
  </div>
</div>
